import { Property } from "./interfaces";

export const codDiagnosticoPrincipal: Property = {
    title: "Código de Diagnóstico Principal",
    type: "string",
}